import { IUserFromBack, TRole } from "@/types";

export default class User implements IUserFromBack {
    public id: number;
    public name: string;
    public email: string;
    public role: TRole;
    public created_at: number;
    public updated_at: number;
    public current: boolean;
    public isSession: boolean;

    constructor(user: IUserFromBack) {
        this.id = user.id;
        this.name = user.name;
        this.email = user.email;
        this.role = user.role;
        this.created_at = user.created_at;
        this.updated_at = user.updated_at;
        this.current = user.current;
        this.isSession = user.isSession;
    }
}